import OBase from './OBase';
import * as Geometry from '../geometry';

export default class EPointArray extends OBase {
  update () {
    let pointP1Tree = this.getVector3Input('Point 1', false);
    let pointP2Tree = this.getVector3Input('Point 2', false);
    let divTree = this.getFloatInput('Division');

    let output = this.outputs['Point List'].paramObject;

    let p1GraftTree = this.graft(pointP1Tree);
    let p2GraftTree = this.graft(pointP2Tree);
    let divGraftTree = this.graft(divTree);

    let dataTrees = [p1GraftTree, p2GraftTree, divGraftTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree = new Geometry.DataTree();

    // let points = []

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let path = outDataTrees[0].paths[i];
        let pt1 = outDataTrees[0].branches[i][j];
        let pt2 = outDataTrees[1].branches[i][j];
        let div = outDataTrees[2].branches[i][j];

        let dir = pt2.clone();
        dir.sub(pt1);
        dir.divideScalar(div);

        for (let n = 0; n < div + 1; n++) {
          let dir2 = dir.clone();
          dir2.multiplyScalar(n);
          let npos = pt1.clone();
          npos.add(dir2);

          outTree.add(npos, path);
          // points.push(npos)
        }
      }
    }

    // global.debugger.addPoints(points)

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EPointArray.js